import { makeRequest } from "./general";

const apiUrl = window.apiUrl;
const tokenAccess = "ab4e8143-36b5-4dcd-b5d9-0700bcab9a69";
export default class ClientService {
  constructor() {
    this.baseUrl = apiUrl;
  }

  async sendFormPeople(formData) {
    const url = `${this.baseUrl}/api/CardOrder/`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ACCESS_KEY: tokenAccess,
      },
      body: JSON.stringify(formData),
    };
    return await makeRequest(url, params);
  }
}
